<table data-test="Tl13y496" class="items-table sticky-thead" data-offset="48">
  <thead data-test="B-UU6Sxo" class="text-center">
    <tr data-test="0lUF4GTu" class="items-table__header">
      <th data-test="iY73dXSd" class="text-left">
        <span
          data-test="ZXyr6hTR"
          class="items-table__sort"
          [class.active]="sorter.type === sorterTypes.STATUS"
          (click)="sortBy(sorterTypes.STATUS)"
        >
          Status
        </span>
      </th>
      <th data-test="DqdO_Pso" class="text-left">
        <span
          data-test="zWuI02JJ"
          class="items-table__sort"
          [class.active]="sorter.type === sorterTypes.NAME"
          (click)="sortBy(sorterTypes.NAME)"
        >
          Name
        </span>
        <!-- <button class="icon icon_sm">
          <svg class="icon__icon-filter" width="10px" height="10px">
            <use xlink:href="#icon-filter"></use>
          </svg>
        </button> -->
      </th>
      <th data-test="tL05cOOU" class="text-left">Companies</th>
      <th data-test="52zTnntx" *ngFor="let role of roles">
        <span data-test="Xrb5FgB9">
          <b data-test="z78OSx-q" class="text-large underline">{{ role.name }}</b>
        </span>
        <button data-test="WSBR60fW" class="badge badge_fill-gray badge_sm">
          <svg
            data-test="wYx_87jO"
            class="icon__icon-info"
            width="4.64px"
            height="10.51px"
          >
            <use xlink:href="#icon-info"></use>
          </svg>
        </button>
      </th>
      <th data-test="cwJtOKGQ" class="pr-0 text-right">
        <button
          data-test="uAElrIj0"
          (click)="handleAddRole()"
          class="button button_label button_primary"
        >
          <span data-test="GC_BtwYj" class="button__icon mr-1">
            <i data-test="ddsL3NQw" class="material-icons">add</i>
          </span>
          <span data-test="YkNYN337">role</span>
        </button>
      </th>
    </tr>
  </thead>
  <tbody data-test="r3Ui3esl" class="text-center">
    <tr
      data-test="Lk0tj4FG"
      class="row-type"
      [class.row-type_purple]="user.status === userStatuses.INACTIVE"
      [class.row-type_green]="user.status === userStatuses.ACTIVE"
      [class.row-type_gray]="user.status === userStatuses.DRAFT"
      [class.row-type_green]="user.status === userStatuses.ACTIVE"
      [class.row-type_yellow]="user.status === userStatuses.PENDING"
      *ngFor="let user of users"
    >
      <td data-test="Q1kpzwPX" class="text-left">
        <div data-test="I87Ih2M6" class="d-flex">
          <span
            data-test="trziHsC4"
            *ngIf="user.status === userStatuses.ACTIVE"
            class="label label_green"
          >
            {{ userStatuses.ACTIVE | titlecase }}
          </span>
          <span
            data-test="H0jyVw7D"
            *ngIf="user.status === userStatuses.INACTIVE"
            class="label label_purple"
          >
            {{ userStatuses.INACTIVE | titlecase }}
          </span>
          <span
            data-test="ww9Bz3Nw"
            *ngIf="user.status === userStatuses.DRAFT"
            class="label label_gray"
          >
            {{ userStatuses.DRAFT | titlecase }}
          </span>
          <span
            data-test="mmXccv6B"
            *ngIf="user.status === userStatuses.PENDING"
            class="label label_yellow"
          >
            {{ userStatuses.PENDING | titlecase }}
          </span>
        </div>
      </td>
      <td data-test="gBe4IHml" class="text-left">
        <div data-test="a94zJkY4" class="items-table__img-block">
          <div
            data-test="9cSehMmG"
            class="img-square"
            *ngIf="user.contactPhotoFilename"
            [ngStyle]="{
              'background-image': 'url(' + imagesPath + user.contactPhotoFilename + ')'
            }"
          ></div>
          <div data-test="bfONlzMu" class="items-table__img-block-title">
            <b data-test="ha20UvlB">{{ user.firstName }} {{ user.lastName }}</b>
            <span data-test="uUaqaY5J">{{ user.username }}</span>
          </div>
        </div>
      </td>
      <td data-test="f-dtljtI" class="text-left cell-br cell-br">
        <ng-container *ngIf="user.companies.length > 1">
          <ng-container *ngFor="let company of user.companies">
            <div data-test="PPFhctjw" class="items-table__img-block">
              <div
                data-test="WgyV67hB"
                class="img-square"
                [style.background-image]="
                  company.logo ? 'url(' + imagesPath + company.logo + ')' : ''
                "
                title="{{ company.name }}"
              ></div>
            </div>
            &nbsp;
          </ng-container>
        </ng-container>
        <ng-container *ngIf="user.companies.length === 1">
          <div data-test="0tSNqQNw" class="items-table__img-block">
            <div
              data-test="W_ks2GwH"
              class="img-square"
              [style.background-image]="
                user.companies[0].logo
                  ? 'url(' + imagesPath + user.companies[0].logo + ')'
                  : ''
              "
            ></div>
            <div data-test="qZ_MHMH_" class="items-table__img-block-title">
              {{ user.companies[0].name }}
            </div>
          </div>
        </ng-container>
      </td>
      <td
        data-test="frFr1nHP"
        [class.cell-br]="i !== roles.length - 1"
        *ngFor="let role of roles; odd as isOdd; let i = index"
        [class.cell-bg]="!isOdd"
      >
        <span data-test="otnma8O-" class="text-green" *ngIf="roleOf(user, role)">
          <i data-test="RWYR__HY" class="material-icons md-24">check_circle</i>
        </span>
      </td>
      <td data-test="dOoojIY1" class="items-table__more">
        <div data-test="Z615DDNV" class="dropdown-hover">
          <button data-test="CErjbisy" class="items-table__icon">
            <svg data-test="t-y4Q2_1" class="icon__icon-more" width="3px" height="13px">
              <use xlink:href="#icon-more"></use>
            </svg>
          </button>
          <div
            data-test="dWJZ4Um5"
            class="dropdown items-table__dropdown dropdown_bottom-right dropdown_arrow"
            id=""
          >
            <div data-test="zXEkOE1l" class="dropdown__wrap">
              <ul data-test="p9zeHMQm" class="dropdown__menu">
                <li data-test="BFeorAho" class="dropdown__menu-item">
                  <a
                    data-test="E5OPwWYI"
                    class="dropdown__menu-link"
                    data-modal=""
                    routerLink="{{ detailsLink }}/{{ user.uuid }}"
                  >
                    <div data-test="MQ6YD9uH" class="icon">
                      <svg
                        data-test="049uXjFV"
                        class="icon__icon-view"
                        width="14.01px"
                        height="11px"
                      >
                        <use xlink:href="#icon-view"></use>
                      </svg>
                    </div>
                    Details
                  </a>
                </li>
                <li
                  data-test="fpd86UJa"
                  class="dropdown__menu-item"
                  *ngIf="
                    user.status === userStatuses.INACTIVE ||
                    user.status === userStatuses.PENDING
                  "
                  [class.disabled]="!user.roleUnits?.length"
                >
                  <a
                    data-test="bWi_XP9V"
                    class="dropdown__menu-link"
                    data-modal=""
                    (click)="setUserStatus(userStatuses.ACTIVE, user)"
                  >
                    <div data-test="279qkZ8a" class="icon">
                      <svg
                        data-test="E34TZwqx"
                        class="icon__icon-accept"
                        width="13.97px"
                        height="13px"
                      >
                        <use xlink:href="#icon-accept"></use>
                      </svg>
                    </div>
                    Activate
                  </a>
                </li>
                <li
                  data-test="p0Bub9iy"
                  class="dropdown__menu-item"
                  *ngIf="user.status === userStatuses.DRAFT"
                  [class.disabled]="!user.roleUnits?.length"
                >
                  <a
                    data-test="rsEp810j"
                    class="dropdown__menu-link"
                    data-modal=""
                    (click)="sendUserInvitation(user)"
                  >
                    <div data-test="zXjo1V-b" class="icon">
                      <svg
                        data-test="jg8A-YDD"
                        class="icon__icon-accept"
                        width="13.97px"
                        height="13px"
                      >
                        <use xlink:href="#icon-accept"></use>
                      </svg>
                    </div>
                    Send Invite
                  </a>
                </li>
                <li
                  data-test="Y4dlg5a_"
                  class="dropdown__menu-item"
                  *ngIf="user.status === userStatuses.PENDING"
                  [class.disabled]="!user.roleUnits?.length"
                >
                  <a
                    data-test="ir1f662r"
                    class="dropdown__menu-link"
                    data-modal=""
                    (click)="sendUserInvitation(user)"
                  >
                    <div data-test="rQiCcLIR" class="icon">
                      <svg
                        data-test="wKOW6zLr"
                        class="icon__icon-accept"
                        width="13.97px"
                        height="13px"
                      >
                        <use xlink:href="#icon-accept"></use>
                      </svg>
                    </div>
                    Resend Invite
                  </a>
                </li>
                <li
                  data-test="qgPcz21w"
                  class="dropdown__menu-item"
                  *ngIf="user.status === userStatuses.ACTIVE"
                >
                  <a
                    data-test="baO4QWZV"
                    class="dropdown__menu-link"
                    data-modal=""
                    (click)="setUserStatus(userStatuses.INACTIVE, user)"
                  >
                    <div data-test="qqeVfuux" class="icon">
                      <svg
                        data-test="lVqD8FyC"
                        class="icon__icon-accept"
                        width="13.97px"
                        height="13px"
                      >
                        <use xlink:href="#icon-accept"></use>
                      </svg>
                    </div>
                    Deactivate
                  </a>
                </li>
                <li
                  data-test="Xnlb8a7S"
                  class="dropdown__menu-item"
                  *ngIf="user.status !== userStatuses.ACTIVE"
                >
                  <a
                    data-test="faDagBfi"
                    class="dropdown__menu-link text-red"
                    data-modal=""
                    (click)="deleteUser(user)"
                  >
                    <div data-test="0dQ7aNuH" class="icon">
                      <svg
                        data-test="NL4PQt6T"
                        class="icon__icon-trash"
                        width="10px"
                        height="11px"
                      >
                        <use xlink:href="#icon-trash"></use>
                      </svg>
                    </div>
                    Delete
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </td>
    </tr>
  </tbody>
</table>
